import { BASE_AUTH_TOKEN, ROUTE_LOGIN } from '@/common/constants';
import useStore from '@/lib/store';
import { Loader2 } from 'lucide-react';
import { Fragment, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const RouteGuard = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { user, fetchUser } = useStore();

  const token = localStorage.getItem(BASE_AUTH_TOKEN);
  useEffect(() => {
    const initAuth = async () => {
      try {
        if (token && !user) {
          await fetchUser();
        }
      } catch (error) {
        console.error('Auth initialization failed:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initAuth();
  }, [token]);

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!token && pathname !== ROUTE_LOGIN) {
    return <Navigate to={ROUTE_LOGIN} replace />;
  }

  // if (token && pathname === ROUTE_LOGIN) {
  //   return <Navigate to={ROUTE_LOADS} replace />;
  // }

  return <Fragment>{children}</Fragment>;
};
